/**
 * @generated SignedSource<<69f1cd703afd913099fd8631e4fc83bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type CreateDpcRootDeployQuery$variables = {
  agFilterElement?: FilterElementInput | null | undefined;
};
export type CreateDpcRootDeployQuery$data = {
  readonly accountGroups: {
    readonly pageInfo: {
      readonly total: number | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"useProblemsAlert_problems">;
  };
};
export type CreateDpcRootDeployQuery = {
  response: CreateDpcRootDeployQuery$data;
  variables: CreateDpcRootDeployQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agFilterElement"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "agFilterElement"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDpcRootDeployQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountGroupConnection",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useProblemsAlert_problems"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDpcRootDeployQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountGroupConnection",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "problems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Problems",
            "abstractKey": "__isProblems"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35ea3719ce313fadca5e678f08c1169a",
    "id": null,
    "metadata": {},
    "name": "CreateDpcRootDeployQuery",
    "operationKind": "query",
    "text": "query CreateDpcRootDeployQuery(\n  $agFilterElement: FilterElementInput\n) {\n  accountGroups(filterElement: $agFilterElement) {\n    pageInfo {\n      total\n    }\n    ...useProblemsAlert_problems\n  }\n}\n\nfragment useProblemsAlert_problems on Problems {\n  __isProblems: __typename\n  problems {\n    __typename\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "62076314bf5b091383324655ff0bae24";

export default node;
